module.exports = __webpack_public_path__ + "static/media/floating_pane.46fc0e49.gif";